import yup from '@/libs/yup';

export default yup.object().shape({
    idn: yup.string().idn(),
    storage_id: yup.string().required()
});
